import Container from 'react-bootstrap/Container';
import { useEffect, useState } from "react";

function Header() {

   const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight - 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const brandIcon = <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-activity" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M6 2a.5.5 0 0 1 .47.33L10 12.036l1.53-4.208A.5.5 0 0 1 12 7.5h3.5a.5.5 0 0 1 0 1h-3.15l-1.88 5.17a.5.5 0 0 1-.94 0L6 3.964 4.47 8.171A.5.5 0 0 1 4 8.5H.5a.5.5 0 0 1 0-1h3.15l1.88-5.17A.5.5 0 0 1 6 2" />
  </svg>


  const emailIcon = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-envelope-heart" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l3.235 1.94a2.8 2.8 0 0 0-.233 1.027L1 5.384v5.721l3.453-2.124q.219.416.55.835l-3.97 2.443A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741l-3.968-2.442q.33-.421.55-.836L15 11.105V5.383l-3.002 1.801a2.8 2.8 0 0 0-.233-1.026L15 4.217V4a1 1 0 0 0-1-1zm6 2.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132" />
  </svg>

  const git = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-github" viewBox="0 0 16 16">
    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8" />
  </svg>

  const linkedin = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
  </svg>

  const behance = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-behance" viewBox="0 0 16 16">
    <path d="M4.654 3c.461 0 .887.035 1.278.14.39.07.711.216.996.391s.497.426.641.747c.14.32.216.711.216 1.137 0 .496-.106.922-.356 1.242-.215.32-.566.606-.997.817.606.176 1.067.496 1.348.922s.461.957.461 1.563c0 .496-.105.922-.285 1.278a2.3 2.3 0 0 1-.782.887c-.32.215-.711.39-1.137.496a5.3 5.3 0 0 1-1.278.176L0 12.803V3zm-.285 3.978c.39 0 .71-.105.957-.285.246-.18.355-.497.355-.887 0-.216-.035-.426-.105-.567a1 1 0 0 0-.32-.355 1.8 1.8 0 0 0-.461-.176c-.176-.035-.356-.035-.567-.035H2.17v2.31c0-.005 2.2-.005 2.2-.005zm.105 4.193c.215 0 .426-.035.606-.07.176-.035.356-.106.496-.216s.25-.215.356-.39c.07-.176.14-.391.14-.641 0-.496-.14-.852-.426-1.102-.285-.215-.676-.32-1.137-.32H2.17v2.734h2.305zm6.858-.035q.428.427 1.278.426c.39 0 .746-.106 1.032-.286q.426-.32.53-.64h1.74c-.286.851-.712 1.457-1.278 1.848-.566.355-1.243.566-2.06.566a4.1 4.1 0 0 1-1.527-.285 2.8 2.8 0 0 1-1.137-.782 2.85 2.85 0 0 1-.712-1.172c-.175-.461-.25-.957-.25-1.528 0-.531.07-1.032.25-1.493.18-.46.426-.852.747-1.207.32-.32.711-.606 1.137-.782a4 4 0 0 1 1.493-.285c.606 0 1.137.105 1.598.355.46.25.817.532 1.102.958.285.39.496.851.641 1.348.07.496.105.996.07 1.563h-5.15c0 .58.21 1.11.496 1.396m2.24-3.732c-.25-.25-.642-.391-1.103-.391-.32 0-.566.07-.781.176s-.356.25-.496.39a.96.96 0 0 0-.25.497c-.036.175-.07.32-.07.46h3.196c-.07-.526-.25-.882-.497-1.132zm-3.127-3.728h3.978v.957h-3.978z" />
  </svg>
  // const phoneNumber = '7019898582'; 
  const medium = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-medium" viewBox="0 0 16 16">
  <path d="M9.025 8c0 2.485-2.02 4.5-4.513 4.5A4.506 4.506 0 0 1 0 8c0-2.486 2.02-4.5 4.512-4.5A4.506 4.506 0 0 1 9.025 8m4.95 0c0 2.34-1.01 4.236-2.256 4.236S9.463 10.339 9.463 8c0-2.34 1.01-4.236 2.256-4.236S13.975 5.661 13.975 8M16 8c0 2.096-.355 3.795-.794 3.795-.438 0-.793-1.7-.793-3.795 0-2.096.355-3.795.794-3.795.438 0 .793 1.699.793 3.795"/>
</svg>

  // const handleWhatsAppClick = () => {
  //   const url = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
  //   window.open(url, '_blank');
  // };
  return (
    <div className={`header-container ${scrolled ? "scrolled" : ""}`}>
      <Container className='navbar custom-navbar'>
        <div>
          {/* <h1 style={{ fontFamily: 'Arial, sans-serif', fontSize: '28px', fontWeight: 'bold', margin: '0' }}>
          IAMDIVS
        </h1> */}
          <h2 >
            <a href="/"
              style={{ fontFamily: 'cursive', fontSize: '28px', margin: '0', padding: "5px 0", textDecoration: "none", color: "#000" }}>
              IAMDIVS <em>{brandIcon}</em>
            </a>
          </h2>
          {/* <h1>
      <em>IAMDIV</em><strong>{brandIcon}</strong>
      </h1> */}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px', padding: "5px 0" }}>
        <span className='header_icon'>
            <p style={{ marginBottom: '0' }}>
              <a href="https://dev.to/iam_divs" target='_Dev' title="Dev Community" className='dev-link'  style={{ fontFamily: 'cursive', fontSize: '18px', padding: "5px" }}>
                DEV
              </a>
            </p>
          </span>
          {/* <span className='header_icon'>
            <button style={{ border: "none", background: "none" }} title="Whatsapp" onClick={handleWhatsAppClick} >
              {whatsApp}
            </button>
          </span> */}
          <span className='header_icon'>
            <p style={{ marginBottom: '0' }}>
              <a href="mailto: divyatlng0@gmail.com"  target='_mail' className='email-link' title="Email" >
                {emailIcon}
              </a>
            </p>
          </span>
          <span className='header_icon'>
            <p style={{ marginBottom: '0' }}>
              <a href="https://github.com/divs94" target='git' className='git-link' title="GitHub" >
                {git}
              </a>
            </p>
          </span>
          <span className='header_icon'>
            <p style={{ marginBottom: '0' }}>
              <a href="https://www.linkedin.com/in/divyatailang" title="Linkedin" className='linkedin-link' target='_in' >
                {linkedin}
              </a>
            </p>
          </span>
          <span className='header_icon'>
            <p style={{ marginBottom: '0' }}>
              <a href="https://dribbble.com/iam_divs" target='_Dr' title="Dribble" className='dribble-link' style={{ fontFamily: 'cursive', fontSize: '18px', padding: "5px" }}>
                D
              </a>
            </p>
          </span>
          <span className='header_icon'>
            <p style={{ marginBottom: '0' }}>
              <a href="https://www.behance.net/divyatailang" title="Behance" className='behance-link' target='_be' >
                {behance}
              </a>
            </p>
          </span>
          <span className='header_icon'>
            <p style={{ marginBottom: '0' }}>
              <a href="https://medium.com/@iam_divs" target='_be' className='medium-link' title="Medium" >
                {medium}
              </a>
            </p>
          </span>
          <span className='header_icon'>
            <p style={{ marginBottom: '0' }}>
              <a href="https://www.figma.com/@iam_divs" target='_fg' title="Figma" className='figma-link'  style={{ fontFamily: 'cursive', fontSize: '18px', padding: "5px" }}>
                F
              </a>
            </p>
          </span>
        </div>
      </Container>
    </div>
  );
}

export default Header;